import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  width: 100%;
  color: ${({ bundleButtonTextColor }: any) => bundleButtonTextColor};
  font-family: ${({ fontFamily }: any) => fontFamily};
  direction: ${(props: any) => props.direction};

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    white-space: nowrap;
    font-weight: 900;

    span {
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3),
        -0.5px 0.5px 0 rgb(0, 101, 43), 0.5px -0.5px 0 rgb(0, 101, 43),
        -0.5px -0.5px 0 rgb(0, 101, 43), 0.5px 0.5px 0 rgb(0, 101, 43);
      font-weight: 900;
    }
  }
` as any;

export const StyledBundlePrice = styled.div`
  background-image: ${(props: any) => `url("${props.background}")`};
  background-size: cover;
  background-position: center;
  height: 41px;
  width: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 9px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: ${breakpoints.mobileL}) {
    height: 44.35px;
    width: 175.3px;
  }
` as any;
